import {
  GoogleMap,
  MarkerF,
  OverlayViewF,
  OVERLAY_MOUSE_TARGET,
  useJsApiLoader,
  Libraries
} from '@react-google-maps/api';
import {useTheme, useMediaQuery, Link, Button} from '@mui/material';
import {useTranslation} from 'react-i18next';
import DirectionsIcon from '@mui/icons-material/Directions';
import {env} from '@/config';

const {GOOGLE_MAPS_API_KEY} = env || '<missing>';
const LIBRARIES = ['places'] as Libraries;

interface Location extends google.maps.LatLngLiteral {
  lat: number;
  lng: number;
}

interface EventLocationProps {
  eventLocationCoords: Location;
}

export const EventLocation: React.FC<EventLocationProps> = ({
  eventLocationCoords
}) => {
  const theme = useTheme();
  const isSmScreenOrUp = useMediaQuery(theme.breakpoints.up('xs'));
  const isSmOrMdScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const {t} = useTranslation();

  const {isLoaded} = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: LIBRARIES
  });

  if (
    !eventLocationCoords ||
    typeof eventLocationCoords.lat !== 'number' ||
    typeof eventLocationCoords.lng !== 'number'
  ) {
    return <div>Loading...</div>;
  }

  if (!isLoaded) return <div>Loading...</div>;

  const mapContainerStyle = {
    height: isSmScreenOrUp ? '240px' : '150px',
    width: '100%'
  };

  const directionsUrl = `https://www.google.com/maps/dir//${eventLocationCoords.lat},${eventLocationCoords.lng}`;

  const markerPosition = {
    lat: eventLocationCoords.lat,
    lng: eventLocationCoords.lng
  };

  return (
    <div>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={markerPosition}
        zoom={12}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
          zoomControl: !isSmOrMdScreen,
          fullscreenControl: false,
          disableDefaultUI: true
        }}
      >
        <MarkerF position={markerPosition} />
        <OverlayViewF
          position={markerPosition}
          mapPaneName={OVERLAY_MOUSE_TARGET}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '8px',
              pointerEvents: 'auto'
            }}
          >
            {isSmOrMdScreen ? (
              <Link
                href={directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <DirectionsIcon color="primary" style={{fontSize: '50px'}} />
              </Link>
            ) : (
              <Button
                variant="contained"
                color="primary"
                href={directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  opacity: 0.8,
                  backgroundColor: theme.palette.primary.dark,
                  maxWidth: '150px',
                  marginLeft: '-75px',
                  fontSize: {
                    xs: '0.65rem',
                    sm: '0.85rem'
                  }
                }}
              >
                {t('directions')}
              </Button>
            )}
          </div>
        </OverlayViewF>
      </GoogleMap>
    </div>
  );
};
